// validationの英語を日本語に翻訳するためのjs
const message = {
  // Start Forgot password
  ownerId: {
    required: '事業者IDは必須項目です。'
  },
  userId: {
    required: 'ユーザーIDは必須項目です。'
  },
  resetCode: {
    required: 'リセットコードは必須項目です。',
    numeric: 'リセットコードは数字のみ入力してください。'
  },
  oldPassword: {
    required: '現在のパスワードは必須項目です。'
  },
  newPassword: {
    required: 'パスワードは必須項目です。',
    confirmed: '「新しいパスワード」と一致しません。',
    min: 'パスワードは8文字以上で入力してください。',
    max: 'パスワードは64文字以下で入力してください。',
    regex: 'パスワードは英大文字、英小文字、数字を組み合わせた8文字以上に設定してください。'
  },
  // End Forgot password
  // Start Login
  password: {
    required: 'パスワードは必須項目です。'
  }
  // End Login
}
export default message



// WEBPACK FOOTER //
// ./src/strings/validator/messages/ja.js